import { render, staticRenderFns } from "./MyProfileEdit.vue?vue&type=template&id=31b14a55&scoped=true"
import script from "./MyProfileEdit.vue?vue&type=script&lang=js"
export * from "./MyProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./MyProfileEdit.vue?vue&type=style&index=0&id=31b14a55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b14a55",
  null
  
)

export default component.exports